// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--a2fe4";
export var siteBy = "footer-module--siteBy--52fac";